export default [
    {
        name: '__slot:zen_report_concurrent_title',
        sortField: 'name',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'similarTagsCount',
        sortField: 'similarTagsCount',
        type: 'number',
        useInFilter: true,
        callback: 'numberExt',
    },
    {
        name: 'countPosts',
        sortField: 'countPosts',
        type: 'number',
        useInFilter: true,
        callback: 'numberExt',
    },
    {
        name: 'countViews',
        sortField: 'countViews',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'numberExt',
    },
    {
        name: 'auditory',
        sortField: 'auditory',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'numberExt',
    },
    {
        name: 'subscribers',
        sortField: 'subscribers',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'numberExt',
    },
]
